/**
 * Wheel event handler for Monaco editor container on macOS and other browsers.
 *
 * Prevents horizontal trackpad swipe gestures from bubbling out of the editor and
 * triggering browser Back/Forward navigation.
 *
 * Normal vertical scrolling (deltaX === 0) is never prevented, allowing vertical
 * mouse/trackpad wheel scrolling to operate unhindered.
 */
export function handleEditorWheel(e: WheelEvent): boolean {
  if (Math.abs(e.deltaX) > 0) {
    e.preventDefault();
    return true;
  }
  return false;
}
